var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { DateTime } from "luxon";
import * as React from 'react';
import { Link } from "react-router-dom";
import { Button, Checkbox, Dimmer, Grid, Header, Loader, Menu, Message, Popup, } from "semantic-ui-react";
import { getWithAuthn, postWithAuthn } from "../RequestHelpers";
import 'react-datepicker/dist/react-datepicker.css';
import ReactTable from "react-table";
import { AppPaths } from "../AppConfig";
import * as countries from '../countries.json';
import DateRangePicker from "./DateRangePicker";
import ProbeDesignReviewModal from "./ProbeDesignReviewModal";
var AllOrdersPage = /** @class */ (function (_super) {
    __extends(AllOrdersPage, _super);
    function AllOrdersPage(props) {
        var _this = _super.call(this, props) || this;
        _this.fileInputRef = React.createRef();
        _this.renderStatusPicker = function (config) {
            return React.createElement(Grid, { columns: 2, celled: 'internally' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement("h4", null, "Production statuses"),
                        config.prodStatuses.map(function (s, index) {
                            var onChange = function (_, data) {
                                var checked = data.checked;
                                _this.setState(function (oldState) {
                                    var set = new Set(oldState.prodStatuses);
                                    if (checked) {
                                        set.add(s);
                                    }
                                    else {
                                        set.delete(s);
                                    }
                                    return {
                                        prodStatuses: set
                                    };
                                }, _this.loadOrders);
                            };
                            return React.createElement("div", { key: index },
                                React.createElement(Checkbox, { checked: _this.state.prodStatuses.has(s), label: s, onChange: onChange }));
                        })),
                    React.createElement(Grid.Column, null,
                        React.createElement("h4", null, "Payment statuses"),
                        config.pmtStatuses.map(function (s, index) {
                            var onChange = function (_, data) {
                                var checked = data.checked;
                                _this.setState(function (oldState) {
                                    var set = new Set(oldState.pmtStatuses);
                                    if (checked) {
                                        set.add(s);
                                    }
                                    else {
                                        set.delete(s);
                                    }
                                    return {
                                        pmtStatuses: set
                                    };
                                }, _this.loadOrders);
                            };
                            return React.createElement("div", { key: index },
                                React.createElement(Checkbox, { checked: _this.state.pmtStatuses.has(s), label: s, onChange: onChange }));
                        }))));
        };
        _this.renderColumnToggles = function (columns) {
            return React.createElement(Grid, { columns: 1, celled: 'internally' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null, columns.map(function (s, index) {
                        var onChange = function (_, data) {
                            var checked = data.checked;
                            _this.setState(function (oldState) {
                                var set = new Set(oldState.filteredColumns);
                                if (checked) {
                                    set.add(s);
                                }
                                else {
                                    set.delete(s);
                                }
                                return {
                                    filteredColumns: set
                                };
                            }, _this.loadOrders);
                        };
                        return React.createElement("div", { key: index },
                            React.createElement(Checkbox, { checked: _this.state.filteredColumns.has(s), label: s, onChange: onChange }));
                    }))));
        };
        _this.onIntervalChange = function (interval) {
            _this.setState({
                interval: interval
            }, _this.loadOrders);
        };
        _this.onImportProbeDesigns = function (event) {
            var _a;
            var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
            if (!file)
                return;
            _this.setState({ importLoading: true, importResult: undefined });
            var formData = new FormData();
            formData.append('file', file);
            postWithAuthn('/probe-design/import-probe-designs', formData)
                .then(function (resp) { return resp.json(); })
                .then(function (result) {
                _this.setState({ importLoading: false, importResult: result });
                _this.loadOrders();
            })
                .catch(function (err) {
                console.error('Import failed:', err);
                _this.setState({
                    importLoading: false,
                    importResult: {
                        results: [],
                        errors: ["Import failed: " + err.message],
                        totalProcessed: 0,
                        successful: 0,
                        failed: 1
                    }
                });
            });
            // Reset the file input so the same file can be re-uploaded
            event.target.value = '';
        };
        _this.loadOrders = function () {
            _this.setState({ loading: true }, function () {
                var path = '/admin/orders/all';
                var query = [];
                if (_this.state.interval) {
                    query.push({ key: 'createdNotBefore', value: _this.state.interval.start.toFormat(dateOnlyFormat) });
                    query.push({ key: 'createdNotAfter', value: _this.state.interval.end.toFormat(dateOnlyFormat) });
                }
                query.push({ key: 'prodStatuses', value: Array.from(_this.state.prodStatuses).join(',') });
                query.push({ key: 'pmtStatuses', value: Array.from(_this.state.pmtStatuses).join(',') });
                if (_this.props.userId) {
                    query.push({ key: 'userId', value: _this.props.userId });
                }
                var queryString = '';
                if (query.length > 0) {
                    queryString = '?' + query.map(function (kv) { return encodeURIComponent(kv.key) + "=" + encodeURIComponent(kv.value); })
                        .join('&');
                }
                path = "" + path + queryString;
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            orders: resp.orders
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load orders: " + rej);
                });
            });
        };
        _this.loadOrderListConfig = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn('/admin/orders/list-config')
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        // A user's order history is reviewed whole, so the single-user view
                        // defaults to every status (cancelled included) and no date range.
                        var userScoped_1 = _this.props.userId !== undefined;
                        _this.setState({
                            loading: false,
                            config: resp,
                            prodStatuses: new Set(userScoped_1 ? resp.prodStatuses : resp.defaultProdStatuses),
                            pmtStatuses: new Set(userScoped_1 ? resp.pmtStatuses : resp.defaultPmtStatuses)
                        }, function () {
                            // With no default date range there is no DateRangePicker preset to
                            // trigger the initial fetch, so do it here.
                            if (userScoped_1) {
                                _this.loadOrders();
                            }
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load order list config: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false,
            orders: [],
            prodStatuses: new Set(),
            pmtStatuses: new Set(),
            filteredColumns: defaultFilteredColumns(props.userId !== undefined),
            importLoading: false
        };
        return _this;
    }
    AllOrdersPage.prototype.render = function () {
        var _this = this;
        var countryMap = new Map(countries.map(function (obj) {
            return [obj.value, obj.text];
        }));
        var columns = [
            {
                id: 'id',
                Header: 'Order',
                Cell: function (data) { return React.createElement(Link, { to: AppPaths.ADMIN_ORDER_BASE + "/" + encodeURIComponent(data.value) }, data.value); },
                accessor: function (o) { return o.id; },
                filterable: true,
                filterMethod: function (filter, rows) {
                    return rows.id.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                }
            }
        ];
        if (this.state.filteredColumns.has("customer")) {
            columns = columns.concat([
                {
                    id: 'customerName',
                    Header: 'Customer',
                    Cell: function (data) { return React.createElement(Link, { to: AppPaths.ADMIN_USER_BASE + "/" + encodeURIComponent(data.value.id) }, data.value.name); },
                    accessor: function (o) { return o.user; },
                    sortMethod: function (u1, u2) {
                        var lower1 = u1.name.toLowerCase();
                        var lower2 = u2.name.toLowerCase();
                        if (lower1 < lower2) {
                            return -1;
                        }
                        else if (lower1 > lower2) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.customerName.name.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("organization")) {
            columns = columns.concat([
                {
                    id: 'organization',
                    Header: 'Organization',
                    Cell: function (data) { return data.value.organization; },
                    accessor: function (o) { return o.user; },
                    sortMethod: function (u1, u2) {
                        var lower1 = u1.organization.toLowerCase();
                        var lower2 = u2.organization.toLowerCase();
                        if (lower1 < lower2) {
                            return -1;
                        }
                        else if (lower1 > lower2) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.organization.organization.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("purchaseOrders")) {
            columns = columns.concat([
                {
                    id: 'poUploads',
                    Header: 'Purchase Orders',
                    Cell: function (data) { return data.value.join(", "); },
                    accessor: function (o) { return o.poUploads; },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.poUploads.join(", ").toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("country")) {
            columns = columns.concat([
                {
                    id: 'shippingCountry',
                    Header: 'Country',
                    Cell: function (data) { return React.createElement("a", { href: "https://www.google.com/maps/search/" + encodeURIComponent(data.value.street) + ",+" + encodeURIComponent(data.value.city + " " + data.value.stateProvince + " " + data.value.zipPostalCode) + ",+" + encodeURIComponent(data.value.countryCode) },
                        data.value.countryCode,
                        " (",
                        countryMap.get(data.value.countryCode),
                        ")"); },
                    accessor: function (o) { return o.shippingAddress; },
                    sortMethod: function (a1, a2) {
                        if (a1.countryCode < a2.countryCode) {
                            return -1;
                        }
                        else if (a1.countryCode > a2.countryCode) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        var countryCode = rows.shippingCountry.countryCode;
                        var countryName = countryMap.get(countryCode);
                        var country = countryCode + " (" + countryName + ")";
                        return country.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("stateProvince")) {
            columns = columns.concat([
                {
                    id: 'stateProvince',
                    Header: 'State/Province',
                    Cell: function (data) { return React.createElement("a", { href: "https://www.google.com/maps/search/" + encodeURIComponent(data.value.street) + ",+" + encodeURIComponent(data.value.city + " " + data.value.stateProvince + " " + data.value.zipPostalCode) + ",+" + encodeURIComponent(data.value.countryCode) }, data.value.stateProvince); },
                    accessor: function (o) { return o.shippingAddress; },
                    sortMethod: function (a1, a2) {
                        if (a1.stateProvince < a2.stateProvince) {
                            return -1;
                        }
                        else if (a1.stateProvince > a2.stateProvince) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    },
                    minWidth: 50,
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.stateProvince.stateProvince
                            .toLowerCase()
                            .indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("organisms")) {
            columns = columns.concat([
                {
                    id: 'organisms',
                    Header: 'Organisms',
                    Cell: function (data) { return data.value.join(", "); },
                    accessor: function (o) { return o.organisms; },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.organisms.join(", ").toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("targets")) {
            columns = columns.concat([
                {
                    id: 'targets',
                    Header: 'Targets',
                    Cell: function (data) { return data.value.join(", "); },
                    accessor: function (o) { return o.targets; },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.targets.join(", ").toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("hairpins")) {
            columns = columns.concat([
                {
                    id: 'hairpins',
                    Header: 'Hairpins',
                    Cell: function (data) { return data.value.join(", "); },
                    accessor: function (o) { return o.hairpins; },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.hairpins.join(", ").toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("probeLots")) {
            columns = columns.concat([
                {
                    id: 'probeLots',
                    Header: 'Probe Lots',
                    Cell: function (data) { return data.value.join(", "); },
                    accessor: function (o) { return o.probeLots; },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.probeLots.join(", ").toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("designNumbers")) {
            columns = columns.concat([
                {
                    id: 'designNumbers',
                    Header: 'Design Numbers',
                    Cell: function (data) { return data.value.join(", "); },
                    accessor: function (o) { return o.designNumbers; },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.designNumbers.join(", ").toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("products")) {
            columns = columns.concat([
                {
                    id: 'products',
                    Header: 'Products',
                    Cell: function (data) { return data.value.join(", "); },
                    accessor: function (o) { return o.productsPresent; },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.products.join(", ").toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("kitComments")) {
            columns = columns.concat([
                {
                    id: 'kitComments',
                    Header: 'Kit Comments',
                    Cell: function (data) { return data.value.join(", "); },
                    accessor: function (o) { return o.kitComments; },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.kitComments.join(", ").toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("comments")) {
            columns = columns.concat([
                {
                    id: 'comments',
                    Header: 'Comments',
                    Cell: function (data) { return data.value.join(", "); },
                    accessor: function (o) { return o.comments; },
                    filterable: true,
                    filterMethod: function (filter, rows) {
                        return rows.comments.join(", ").toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                    }
                }
            ]);
        }
        if (this.state.filteredColumns.has("productionStatus")) {
            columns = columns.concat([
                {
                    id: 'prodStatus',
                    Header: 'Production status',
                    accessor: function (o) { return o.prodStatus; }
                }
            ]);
        }
        if (this.state.filteredColumns.has("paymentStatus")) {
            columns = columns.concat([
                {
                    id: 'pmtStatus',
                    Header: 'Payment status',
                    accessor: function (o) { return o.pmtStatus; }
                }
            ]);
        }
        if (this.state.filteredColumns.has("created")) {
            columns = columns.concat([
                {
                    id: 'createdAt',
                    Header: 'Created',
                    Cell: function (data) { return displayLocalTimestamp(data.value); },
                    accessor: function (o) { return o.createdAt; }
                }
            ]);
        }
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { as: 'div', id: this.props.embedded ? undefined : 'non-header-portion' },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                !this.props.embedded && React.createElement(Header, null, "Orders"),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "Orders could not be loaded."),
                this.state.config &&
                    React.createElement(React.Fragment, null,
                        !this.props.embedded &&
                            React.createElement(Menu, null,
                                React.createElement(Menu.Item, null,
                                    React.createElement(ProbeDesignReviewModal, null)),
                                React.createElement(Menu.Item, null,
                                    React.createElement("input", { type: "file", accept: ".csv", ref: this.fileInputRef, style: { display: 'none' }, onChange: this.onImportProbeDesigns }),
                                    React.createElement(Button, { icon: 'upload', label: 'Import Probe Designs', labelPosition: 'left', loading: this.state.importLoading, onClick: function () { var _a; return (_a = _this.fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }))),
                        React.createElement(Menu, null,
                            React.createElement(Menu.Item, null,
                                React.createElement(Button, { icon: 'refresh', onClick: this.loadOrders })),
                            React.createElement(Menu.Item, null,
                                React.createElement(DateRangePicker, { dayRangeOptions: [30, 90, 365], defaultDayRange: this.props.userId ? undefined : 90, interval: this.state.interval, onIntervalChange: this.onIntervalChange, includePresets: true })),
                            React.createElement(Menu.Item, null,
                                React.createElement(Popup, { on: 'click', trigger: React.createElement(Button, { icon: 'check square outline', label: 'Statuses', labelPosition: 'left' }), flowing: true }, this.renderStatusPicker(this.state.config))),
                            React.createElement(Menu.Item, null,
                                React.createElement(Popup, { on: 'click', trigger: React.createElement(Button, { icon: 'check square outline', label: 'Filter Columns', labelPosition: 'left' }), flowing: true }, this.renderColumnToggles(["customer",
                                    "organization",
                                    "purchaseOrders",
                                    "productionStatus",
                                    "paymentStatus",
                                    "country",
                                    "stateProvince",
                                    "created",
                                    "organisms",
                                    "targets",
                                    "hairpins",
                                    "probeLots",
                                    "designNumbers",
                                    "products",
                                    "kitComments",
                                    "comments"
                                ])))),
                        this.state.importResult && (React.createElement(Message, { onDismiss: function () { return _this.setState({ importResult: undefined }); }, positive: this.state.importResult.failed === 0, warning: this.state.importResult.failed > 0 },
                            React.createElement(Message.Header, null,
                                "Import Complete: ",
                                this.state.importResult.successful,
                                " succeeded, ",
                                this.state.importResult.failed,
                                " failed"),
                            this.state.importResult.results.length > 0 && (React.createElement(Message.List, { items: this.state.importResult.results })),
                            this.state.importResult.errors.length > 0 && (React.createElement(Message.List, { items: this.state.importResult.errors })))),
                        React.createElement(ReactTable, { columns: columns, defaultPageSize: 50, minRows: 1, defaultSorted: [{
                                    id: 'createdAt',
                                    desc: true
                                }], data: this.state.orders }))));
    };
    AllOrdersPage.prototype.componentDidMount = function () {
        this.loadOrderListConfig();
    };
    return AllOrdersPage;
}(React.PureComponent));
export default AllOrdersPage;
/**
 * In the single-user view the customer, organization, and address columns would repeat the same
 * value on every row, so they default to hidden there (still available via the column toggles).
 */
var defaultFilteredColumns = function (userScoped) {
    var columns = [
        "order",
        "purchaseOrders",
        "productionStatus",
        "paymentStatus",
        "products",
        "hairpins",
        "probeLots",
        "designNumbers",
        "organisms",
        "targets",
        "created"
    ];
    if (!userScoped) {
        columns.push("customer", "organization", "country", "stateProvince");
    }
    return new Set(columns);
};
export var displayLocalTimestamp = function (utcStr) {
    var dateTime = DateTime.fromISO(utcStr);
    var format = 'yyyy-MM-dd TT';
    return React.createElement("span", { title: "UTC: " + dateTime.toUTC().toFormat(format) }, dateTime.setZone('local').toFormat(format));
};
export var dateOnlyFormat = 'yyyy-MM-dd';
//# sourceMappingURL=AllOrdersPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AllOrdersPage.js
// module id = 41
// module chunks = 0